import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import { EventBus } from '../components/event-bus.js'
import state from './StoreState.js'
import getters from './StoreGetters.js'
import mutations from './StoreMutations.js'
import Edit_meta from '../page/Edit_meta.js'
import List_meta from '../page/List_meta.js'
import default_attribute from './StateDefaultAttribute.js'

var sec_to_time = function (seconds) {
  var hh = parseInt(seconds / 3600) % 24
  var mm = parseInt(seconds / 60) % 60
  if (hh < 10) {
    hh = '0' + hh
  }
  if (mm < 10) {
    mm = '0' + mm
  }
  return hh + ':' + mm
}

Vue.use(Vuex)

// global.previousContactListRequest = []
const actions = {
  // Main
  get_list: function (store, scrollTop) {
    let req = store.getters.listRequest
    store.commit('ListSetLoaded', false)
    return Vue.http.post(
      global.app_path + 'main.php?action=contact_list', {
        req: req,
        token: global.token
      },
      {
        before (request) {
          if (global.previousContactListRequest) {
            global.previousContactListRequest.abort()
          }

          global.previousContactListRequest = request
        }
      })
      .then((response) => {
        var body = response.body
        store.commit('ListSetLoaded', true)
        store.commit('ListResetSelect')
        store.commit('ListSetData', body.data)
        store.commit('ListSetPageCount', body.page_count)
        store.commit('ListSetPage', body.page)
        store.commit('ListSetResTot', body.tot)
        EventBus.$emit('list_set', scrollTop)
      }, (response) => {
        // error callback
      })
  },
  push_list: function (store) {
    let req = store.getters.listRequest
    return Vue.http.post(
      global.app_path + 'main.php?action=contact_list', {
        req: req,
        token: global.token
      },
      {
        before (request) {
          if (global.previousContactListRequest) {
            global.previousContactListRequest.abort()
          }

          global.previousContactListRequest = request
        }
      })
      .then((response) => {
        var body = response.body
        store.commit('ListResetSelect')
        store.commit('ListPushData', body.data)
        store.commit('ListSetPageCount', body.page_count)
        store.commit('ListSetPage', body.page)
        store.commit('ListSetResTot', body.tot)
      }, (response) => {
        // error callback
      })
  },
  // Main
  get_data: function (store, contact_id) {
    let type_id = (store.state.type === 'contact') ? 1 : 2
    console.log('type_id', type_id)
    return Vue.http.post(
      global.app_path + 'main.php?action=contact_data', {
        cid: contact_id,
        type_id: type_id,
        token: global.token
      })
      .then((response) => {
        var body = response.body
        let v
        for (let k in body) {
          v = body[k]
          switch (k) {
            case 'base':
              store.commit('EditSet', {
                key: 'base',
                val: v
              })
              break
            default:
              if (v.length === 0) {
                store.commit('EditSet', {
                  key: k,
                  val: [Edit_meta.blank_states[k]()]
                })
              }
              else {
                store.commit('EditSet', {
                  key: k,
                  val: v
                })
              }
              break
          }
        }
      }, (response) => {
        // error callback
      })
  },
  // Main
  del_contacts: function (store) {
    let ids = store.getters.listSelection.join(',')
    return Vue.http.post(
      global.app_path + 'main.php?action=del', {
        ids: ids,
        token: global.token
      })
      .then((response) => {
        store.dispatch('get_list', false)
      }, (response) => {
        // error callback
      })
  },
  get_groups: function (store) {
    return Vue.http.post(
      global.app_path + 'main.php?action=get_groups', {
        token: global.token
      }
    )
    .then(function (response) {
      store.commit('MetaSetLoaded', {
        key: 'groups',
        value: true
      })
    }, function (response) {

    })
  },
  get_orgs: function (store) {
    return Vue.http.post(
      global.app_path + 'main.php?action=get_orgs', {
        token: global.token
      }
    )
    .then(function (response) {

      store.commit('MetaSetLoaded', {
        key: 'orgs',
        value: true
      })
      
    }, function (response) {

    })
  },
  get_attributes: function (store) {
    return Vue.http.post(
      global.app_path + 'main.php?action=get_attributes', {
        token: global.token
      }
    )
    .then(function (response) {
      let attributes = response.body.data
      store.commit('ListSetAttributes', attributes)
      store.commit('MetaSetLoaded', {
        key: 'attributes',
        value: true
      })
    }, function (response) {

    })
  },
  get_services: function (store) {
    return Vue.http.post(
      global.app_path + 'main.php?action=get_services', {
        token: global.token
      }
      // + (new Date().getTime())
    )
    .then(function (response) {
      let services = response.body.data
      store.commit('SetServices', services)
      store.commit('MetaSetLoaded', {
        key: 'services',
        value: true
      })
    }, function (response) {

    })
  },
  // Main
  del_contact: function (store, id) {
    let ids = store.getters.listSelection.join(',')
    return Vue.http.post(
      global.app_path + 'main.php?action=del', {
        ids: id,
        token: global.token
      })
      .then((response) => {
        // store.dispatch('get_list')
      }, (response) => {
        // error callback
      })
  },
  // Main
  merge_contacts: function (store) {
    let ids = store.getters.listSelection.join(',')
    let mainId = store.getters.listMergeMainId
    return Vue.http.post(
      global.app_path + 'main.php?action=merge', {
        ids: ids,
        main_id: mainId,
        token: global.token
      })
      .then((response) => {
        store.dispatch('get_list', false)
        store.commit('ListSetMergeModalState', false)
      }, (response) => {
        // error callback
      })
  },
  // Headers
  ListSetHeaders: function (store, headers) {
    store.commit('ListSetHeaders', headers)
  },
  // Column display
  listSetHeaderDisplay: function (store, params) {
    store.commit('ListSetHeaderDisplay', {
      header: params.header,
      index: params.index,
      display: params.display
    })
    // store.dispatch('get_list')
  },
  // Column sort
  ListSetHeaderSort: function (store, header) {
    let sort = store.getters.listSort
    if (sort !== null && sort !== header.id) {
      store.commit('ListSetHeaderSort', {
        id: sort,
        sorted: false,
        descending: false
      })
    }

    store.commit('ListSetHeaderSort', {
      id: header.id,
      sorted: true,
      descending: (header.sorted) ? !header.descending : false
    })
  },
  // Page
  ListSetPage: function (store, page) {
    store.commit('ListSetPage', page)
    store.dispatch('get_list')
  },
  // Search
  ListAddSearch: function (store, search) {
    // let search = Edit_meta.get_default_search()
    store.commit('ListAddSearch', search)
  },
  ListDelSearch: function (store, index) {
    store.commit('ListDelSearch', index)
    store.dispatch('get_list')
  },
  ListSetSearch: function (store, params) {
    store.commit('ListSetSearch', params)
    store.dispatch('get_list')
  },
  ListSetSearchField: function (store, params) {
    store.commit('ListSetSearchField', {
      index: params.index,
      field: params.field
    })
    store.dispatch('get_list')
  },
  ListSetSearchMode: function (store, params) {
    store.commit('ListSetSearchMode', {
      index: params.index,
      mode: params.mode
    })
    store.dispatch('get_list')
  },
  listSetSearchType: function (store, type) {
    store.commit('ListSetSearchType', type)
  },
  listSubmitAction: function (store) {
    let type = store.state.type
    let action_req = store.state[type].action_req
    let seeAll = store.state[type].list_req.seeAll
    let is_report = store.state[type].list_req.is_report

    let req = {
      // type: (type === 'contact') ? 1 : 2,
      mode: action_req.mode,
      actions: action_req.actions,
      seeAll: seeAll,
      is_report: is_report,
    }

    // console.log('listSubmitAction', type)
// 
    switch(type){
      case 'contact':
        req.type = 1
      break;
      case 'organisation':
        req.type = 2
      break;
      case 'contact_externe':
        req.type = 3
      break;
      case 'organisation_externe':
        req.type = 4
      break;
    }
    if (action_req.mode === 'search') {
      req.searchs = store.state[state.type].list_req.searchs
    }
    else if (action_req.mode === 'sel') {
      req.sel = store.state[state.type].selected
    }

    req.token = global.token

    return Vue.http.post(
      global.app_path + 'main.php?action=bulk',
      req)
    .then((response) => {
      store.dispatch('get_list')
    }, (response) => {
      // error callback
    })
  },
  listSubmitExport: function (store) {
    let type = store.state.type
    let export_mode = store.state[type].export_mode
    let seeAll = store.state[type].list_req.seeAll
    let is_report = store.state[type].list_req.is_report
    let req = {
      type: (type === 'contact') ? 1 : 2,
      mode: export_mode,
      seeAll: seeAll,
      is_report: is_report,
    }

    if (export_mode === 'search') {
      req.searchs = store.state[state.type].list_req.searchs
    }
    else if (export_mode === 'sel') {
      req.sel = store.state[state.type].selected
    }

    req.token = global.token

    return Vue.http.post(
      global.app_path + 'export.php?action=export',
      req)
    .then((response) => {
      // let contentType = 'text/csv'
      // console.log('response', response.headers.map)
      let contentType = response.headers.map["content-type"][0]
      let contentDisposition = response.headers.map["content-disposition"][0]
      console.log('contentDisposition', contentDisposition)

      const match = contentDisposition.match(/filename="([^"]+)"/)

      var filename = "contact.csv"

      if(match.length > 1) {
        var filename = match[1]
      }

      // console.log('match', match)


      // attachment;filename="contact.xlsx"

      var blob = new Blob(
        [response.body],
        {type: contentType})
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      store.commit('ListSetExportModalState', false)
    }, (response) => {
      // error callback
    })
  },
  listSubmitUnivers: function (store) {
    let type = store.state.type
    // let export_mode = store.state[type].export_mode
    let univers_mode = store.state[type].univers_mode
    let univers_action = store.state[type].univers_action
    let seeAll = store.state[type].list_req.seeAll
    let is_report = store.state[type].list_req.is_report

    let req = {
      type: (type === 'contact') ? 1 : 2,
      mode: univers_mode,
      action: univers_action,
      seeAll: seeAll,
      is_report: is_report,
    }

    if (univers_mode === 'search') {
      req.searchs = store.state[type].list_req.searchs
    }
    else if (univers_mode === 'sel') {
      req.sel = store.state[type].selected
    }

    req.token = global.token

    return Vue.http.post(
      global.app_path + 'main.php?action=set_univers',
      req)
    .then((response) => {
      store.commit('ListSetUniversModalState', false)
      store.dispatch('get_list')
    }, (response) => {
      // error callback
    })
  },
  listSubmitSingleUnivers: function (store) {
    let type = store.state.type
    // let export_mode = store.state[type].export_mode
    let univers_single_action = store.state[type].univers_single_action

    let req = {
      action: univers_single_action.action,
      id: univers_single_action.id
    }

    req.token = global.token

    return Vue.http.post(
      global.app_path + 'main.php?action=set_single_univers',
      req)
  },
  // aCCOUNTS
  get_accounts: function (store) {
    return Vue.http.post(
      global.app_path + 'main.php?action=get_accounts', {
        token: global.token
      })
      .then(function (response) {
        let accounts = response.body
        store.commit('ConfigSetAccounts', accounts)
      },
      function (response) {
        // error callback
      })
  },
  get_auth_page: function (store, user_id) {
    // console.log('get_auth_page', global.oauth_url_base + '&action=get_url')
    return Vue.http.post(
      global.app_path + 'oauth2callback.php?action=get_url',
      {
        redirect_uri: encodeURIComponent(global.oauth_redirect_uri),
        user_id: user_id,
        token: global.token
      },
      {
        // emulateJSON: true
      })
      // global.oauth_url_base + '&action=get_url')
      .then((response) => {
        console.log(response)
        let url = response.body.url
        store.commit('SetAuthPageUrl', url)
        // window.open(response.body.url)
        return url
      }, (response) => {
        // error callback
      })
  },
  split_emails: function (store, data) {
    data.token = global.token
    return Vue.http.post(
      global.app_path + 'main.php?action=split_emails',
      data)
  },
}

global.store = new Vuex.Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  strict: false
  // strict: true
})

export default global.store
